import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import Navbar, { NAVBAR_HEIGHT } from "./Navbar";
import { DayCoachProvider } from "./dayCoach/DayCoachContext";
import DayBriefModal from "./dayCoach/DayBriefModal";
import DayGuide from "./dayCoach/DayGuide";

const FULL_BLEED_PATHS = ["/clientes", "/servicios", "/calendario", "/crm/admin", "/crm/ejecutivo"];

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const isFullBleed = FULL_BLEED_PATHS.some((p) => pathname.startsWith(p));

  return (
    <Box
      sx={{
        height: "100dvh",
        overflow: "hidden",
        bgcolor: "var(--tz-bg)",
        backgroundImage: "var(--tz-glow)",
      }}
    >
      <DayCoachProvider>
      <Navbar />
      <DayBriefModal />
      <DayGuide />

      <Box
        component="main"
        sx={{
          height: "100dvh",
          boxSizing: "border-box",
          pt: `${NAVBAR_HEIGHT}px`,
          overflowY: isFullBleed ? "hidden" : "auto",
          overflowX: "hidden",
          scrollBehavior: "smooth",
          "&::-webkit-scrollbar": { width: "8px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "var(--tz-scroll)",
            borderRadius: "8px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "var(--tz-scroll-hover)",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Box
          sx={{
            px: isFullBleed ? 0 : { xs: 2, sm: 3, lg: 4 },
            py: isFullBleed ? 0 : { xs: 2.5, md: 3.5 },
            maxWidth: isFullBleed ? "none" : 1600,
            mx: "auto",
            ...(isFullBleed && {
              height: "100%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              minWidth: 0,
            }),
          }}
        >
          <Outlet />
        </Box>
      </Box>
      </DayCoachProvider>
    </Box>
  );
}
